'use client'
import React from 'react'

export interface HeaderProps {
    logo?: React.ReactNode
    navigation: React.ReactNode
    search?: React.ReactNode
    extraItems: React.ReactNode
}

export const Header = ({ logo, navigation, search, extraItems }: HeaderProps) => {
    return (
        <div className="shrink-0 w-full h-auto min-h-[3rem] flex items-stretch pl-3 pr-2 density-lg:py-2 border-b border-shade-200 bg-shade-opacity-100 sticky z-20">
            {logo && <div className="h-12 w-auto px-8 my-auto shrink-0">{logo}</div>}
            {navigation && <div className="inline-flex items-stretch density-lg:-my-2 mr-auto">{navigation}</div>}
            {search && <div className="ml-4 my-auto w-56 first:ml-auto">{search}</div>}
            {extraItems && <div className="ml-2 inline-flex items-center my-auto gap-1">{extraItems}</div>}
        </div>
    )
}
